import React, { useState, useEffect } from "react";
import { gamesService } from "../../services/Games/GamesService";
import InfoMessages from "../../components/InfoMessage/InfoMessage";
import { appStore } from "../../stores/appStore";
import GameResult from "./GameResult";
import Loader from "../../components/ui-components/Loader";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { StyledResulsFT, StyledResultHead } from "./ResultsStyle";
import { B2BResize } from "../../services/common/globalFunctions";

const Results = () => {
  const [gameList, setGameList] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [selectLiveNo, setSelectLiveNo] = useState(0);
  const [selectLastSeasonNo, setSelectLastSeasonNo] = useState(0);
  const [btnPreDisable, setBtnPreDisable] = useState(false);
  const [btnNxtDisable, setBtnNxtDisable] = useState(false);

  const { t } = useTranslation("General");

  const { currentLeague, currentSeason, liveWeekNumber, leagueName } = appStore(
    (state) => ({
      currentLeague: state.currentLeague,
      liveWeekNumber: state.liveWeekNumber,
      setLiveWeekNumber: state.setLiveWeekNumber,
      currentSeason: state.currentSeason,
      leagueName: state.leagueName
    })
  );

  // fetching /games/${fkLeagueId}/${fkSeasonId}/${fkWeekId}/results data from server
  useEffect(() => {
    setShowLoader(true);
    const getResults = async () => {
      const response = await gamesService.getResults(
        currentLeague.leagueId,
        selectLastSeasonNo || currentSeason,
        selectLiveNo || liveWeekNumber - 1
      );

      let data = response.data;
      if (data.length > 0) {
        setShowLoader(false);
        setGameList(data);
        setTimeout(() => {
          B2BResize("Results Page");
        }, 500);
      }
    };
    //previous button
    if (selectLiveNo <= 1) {
      setBtnPreDisable(true);
    } else {
      setBtnPreDisable(false);
    }
    //next button
    if (liveWeekNumber - 1 == selectLiveNo || selectLiveNo == 38) {
      setBtnNxtDisable(true);
    } else {
      setBtnNxtDisable(false);
    }
    getResults();
  }, [currentLeague, currentSeason, selectLiveNo]);

  useEffect(() => {
    setSelectLiveNo(liveWeekNumber == 0 ? 38 : liveWeekNumber - 1);
    setSelectLastSeasonNo(
      liveWeekNumber <= 0 ? currentSeason - 1 : currentSeason
    );
  }, [currentSeason]);

  //showing next and previous count
  const previousResult = () => {
    if (selectLiveNo > 1) {
      setSelectLiveNo(selectLiveNo - 1);
    }
  };

  const nextResult = () => {
    if (selectLiveNo <= 38) {
      setSelectLiveNo(selectLiveNo + 1);
    }
  };
  const leagueDisplayName = leagueName && leagueName?.leaguePrefix ? leagueName?.leaguePrefix + currentLeague?.leagueName?.split("-")[1] : currentLeague?.leagueName;

  return showLoader && liveWeekNumber > 1 ? (
    <div className="mb-2">
      <Loader />
    </div>
  ) : (
    <React.Fragment>
      {selectLastSeasonNo === 0 || currentSeason <= 0 ? (
        <InfoMessages messages={<div>{t("First week of the season")}</div>} />
      ) : (
        <React.Fragment>
          <div className="d-flex justify-content-between">
            <div className="fill-full d-flex">
              <button
                className="btn btn  border border-0 m-2 pt-0 mt-0"
                type="button"
                onClick={previousResult}
                disabled={btnPreDisable}
              >
                <FaChevronLeft className="mb-1" />
              </button>
            </div>
            <div>
              <div className="fs-5 fw-bold mb-2">
                {t("Gameweek")}{" "}
                {selectLiveNo == 0 ? 1 : selectLiveNo || liveWeekNumber - 1}
              </div>
            </div>
            <div>
              <button
                className="btn btn border border-0 d-flex m-2 pt-0 mt-1 mb-0"
                type="button"
                onClick={nextResult}
                disabled={btnNxtDisable}
              >
                {" "}
                <FaChevronRight />
              </button>
            </div>
          </div>
          <div className="live-table w-100">
            <StyledResultHead className="row m-0 p-1 bg-primary text-white d-flex justify-content-around justify-items-center align-items-center">
              <div className="col text-start">
                <span>{t(`${leagueDisplayName}`)}</span>&nbsp;
                <span>
                  {t("Season")} #{selectLastSeasonNo}
                </span>
              </div>
              <div className="col text-center fs-4 fw-bold">
                <div className="d-flex justify-content-center align-items-center">
                  <div className="me-1 text-white">
                    <StyledResulsFT>{t("F")}</StyledResulsFT>
                  </div>
                  <span> </span>
                  <div className="ms-1 text-white">
                    <StyledResulsFT>{t("T")}</StyledResulsFT>
                  </div>
                </div>
              </div>
              <div className="col text-end">
                <button className="btn btn-sm bg-info text-dark d-none">
                  <strong>Bet Next</strong>
                </button>
              </div>
            </StyledResultHead>
            {liveWeekNumber == 1 ? (
              <InfoMessages messages={<div>{t("First week of the season")}</div>} />
            ) : (
              <div className="height-100 text-dark px-2">
                {gameList.map((game, index) => (
                  <div
                    className="d-flex justify-content-center border-bottom border-0 align-items-center py-2"
                    key={index}
                  >
                    <GameResult game={game} />
                  </div>
                ))}
              </div>
            )}
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
export default Results;
